import injectScriptTag from '../browserUtils/injectScriptTag';
import buildGoogleMapsURL from './buildGoogleMapsURL';
import getCurrentMapsAPIInstance from './getCurrentMapsAPIInstance';
const loadMapsAPI = ({ URLOptions, handleLoadedAPI }) => {
    const currentMapsAPIInstance = getCurrentMapsAPIInstance();
    if (currentMapsAPIInstance) {
        handleLoadedAPI();
        return;
    }
    const googleMapsURL = buildGoogleMapsURL(URLOptions);
    // @ts-expect-error ts-migrate(2345) FIXME: Argument of type '{ src: string; }' is not assigna... Remove this comment to see the full error message
    injectScriptTag({ src: googleMapsURL });
};
export default loadMapsAPI;
//# sourceMappingURL=loadMapsAPI.js.map